import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export function LoginPage(): JSX.Element {
  const { login, error, loading } = useAuth();
  const [formState, setFormState] = useState({ email: '', password: '' });

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    await login({ email: formState.email, password: formState.password });
  };

  return (
    <div className="mx-auto max-w-md space-y-8">
      <div className="space-y-3 text-center">
        <h1 className="text-3xl font-semibold text-foreground">Welcome back 👋</h1>
        <p className="text-sm text-muted-foreground">
          Log in to resume your inspections. New here?{' '}
          <Link to="/signup" className="text-primary hover:underline">
            Create an account
          </Link>
          .
        </p>
      </div>

      <form onSubmit={handleSubmit} className="glass-card space-y-4 p-6">
        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground" htmlFor="email">
            Email
          </label>
          <input
            id="email"
            type="email"
            required
            value={formState.email}
            onChange={(event) => setFormState((prev) => ({ ...prev, email: event.target.value }))}
            className="focus-ring w-full rounded-xl border border-white/20 bg-white/70 px-3 py-2 text-sm text-foreground outline-none placeholder:text-muted-foreground dark:bg-white/10"
            placeholder="you@agency.com"
          />
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground" htmlFor="password">
            Password
          </label>
          <input
            id="password"
            type="password"
            required
            value={formState.password}
            onChange={(event) => setFormState((prev) => ({ ...prev, password: event.target.value }))}
            className="focus-ring w-full rounded-xl border border-white/20 bg-white/70 px-3 py-2 text-sm text-foreground outline-none placeholder:text-muted-foreground dark:bg-white/10"
            placeholder="••••••••"
          />
        </div>
        <div className="text-right text-xs">
          <Link to="/forgot-password" className="text-primary hover:underline">
            Forgot password?
          </Link>
        </div>

        {error && <p className="rounded-lg bg-destructive/10 px-3 py-2 text-sm text-destructive">{error}</p>}

        <button
          type="submit"
          disabled={loading}
          className="focus-ring inline-flex w-full items-center justify-center rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground shadow-primary/30 transition hover:bg-primary/90 disabled:cursor-not-allowed disabled:opacity-70"
        >
          {loading ? 'Signing in…' : 'Log in'}
        </button>
      </form>
    </div>
  );
}
